(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;

    var spacer = document.querySelector('[data-site-header-spacer]');
    var snail = document.querySelector('[data-snail-scroll-top]');
    var snailImg = header.querySelector('.site-header__snail-img');

    function syncSpacer() {
      var height = header.offsetHeight + 'px';
      document.documentElement.style.setProperty('--header-height', height);
      if (spacer) spacer.style.height = height;
    }

    syncSpacer();
    window.addEventListener('resize', syncSpacer);
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(syncSpacer).observe(header);
    }

    if (snail) {
      snail.addEventListener('click', function (event) {
        event.preventDefault();
        var reduceMotion =
          window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }

    if (!snailImg) return;

    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    var rotation = 0;
    var lastY = window.scrollY || window.pageYOffset;
    var lastTime = performance.now();
    var pending = false;
    // Degrees of rotation per pixel scrolled at a baseline scroll speed (~1px/ms).
    var BASE_DEG_PER_PX = 0.45;
    var SPEED_SCALE = 0.35;

    function onScrollFrame(now) {
      pending = false;
      var y = window.scrollY || window.pageYOffset;
      var delta = y - lastY;
      var dt = Math.max(now - lastTime, 1);
      lastY = y;
      lastTime = now;

      if (delta === 0) return;

      var speed = Math.abs(delta) / dt;
      var multiplier = 1 + speed * SPEED_SCALE;
      rotation += delta * BASE_DEG_PER_PX * multiplier;
      snailImg.style.transform = 'rotate(' + rotation + 'deg)';
    }

    window.addEventListener(
      'scroll',
      function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(onScrollFrame);
      },
      { passive: true }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    var form = document.querySelector('.pdp-form');
    if (!form) return;
    var button = form.querySelector('.pdp-atc');
    var label = form.querySelector('.pdp-atc__label');
    var original = label ? label.textContent : '';

    form.addEventListener('submit', function (event) {
      if (!window.fetch) return;
      event.preventDefault();
      if (button.disabled) return;
      button.disabled = true;
      if (label) label.textContent = label.getAttribute('data-loading') || 'ADDING';

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: Number(form.querySelector('[name="id"]').value),
          quantity: 1
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add_failed');
          return res.json();
        })
        .then(function () {
          if (label) label.textContent = 'ADDED';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('cart:open'));
          setTimeout(function () {
            if (label) label.textContent = original;
            button.disabled = false;
          }, 1200);
        })
        .catch(function () {
          form.submit();
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
